// extracted by mini-css-extract-plugin
module.exports = {"Board":"BoardBuilder_Board__Xl-Rm","Panel":"BoardBuilder_Panel__13Rx4","Buttons":"BoardBuilder_Buttons__1r3J6"};